// extracted by mini-css-extract-plugin
export default {"main":"CompatibilidadSelector_main__vwJZl"};